import { regions } from '@pando/tms-constants/lib/mdm';
import { customerTypes as defaultCustomerTypes } from 'pando-constants';

export const filters = {
  STATUS: 'Status',
};

export const statusList = [
  { id: 1, name: 'Active' },
  { id: 2, name: 'Inactive' },
  { id: -1, name: 'All' },
];

/**
 * Capitalise first letter of each word for display.
 */
const toTitleCase = (str) => str.replace(/\b\w/g, c => c.toUpperCase());

/**
 * Returns customer type dropdown values from custom_fields.
 * Falls back to pando-constants defaults if not configured.
 * @param {Array} customerTypeFields - fields array from mdmBootstrap.consignee_customer_type
 * @returns {string[]} - array of display labels for dropdown
 */
export const getCustomerTypeValues = (customerTypeFields) => {
  if (customerTypeFields && customerTypeFields.length) {
    return customerTypeFields.map(f => f.label);
  }
  return Object.values(defaultCustomerTypes).map(toTitleCase);
};

/**
 * Returns the stored value for a given display label.
 * @param {Array} customerTypeFields - fields array from mdmBootstrap.consignee_customer_type
 * @param {string} label - display label
 * @returns {string} - stored value (lowercase)
 */
export const getCustomerTypeValue = (customerTypeFields, label) => {
  if (customerTypeFields && customerTypeFields.length) {
    const entry = customerTypeFields.find(f => f.label === label);
    if (entry) return entry.name;
  }
  return label.toLowerCase();
};

/**
 * Returns the display label for a stored value.
 * @param {Array} customerTypeFields - fields array from mdmBootstrap.consignee_customer_type
 * @param {string} storedValue - value from DB
 * @returns {string} - display label
 */
export const getCustomerTypeLabel = (customerTypeFields, storedValue) => {
  if (customerTypeFields && customerTypeFields.length) {
    const entry = customerTypeFields.find(f => f.name === storedValue);
    if (entry) return entry.label;
  }
  return storedValue ? toTitleCase(storedValue) : '';
};

export const consigneeForm = [
  [
    { id: 0, label: 'Consignee Name', key: 'name', tlabel: 'MDM_CONSIGNEE_NAME', disabled: false, dataType: 'string', required: true },
    { id: 1, label: 'Reference Id', key: 'reference_id', tlabel: 'MDM_REFERENCE_ID', disabled: false, dataType: 'string', required: true },
    { id: 2, label: 'Address', key: 'address', tlabel: 'MDM_ADDRESS', disabled: false, dataType: 'string', required: false },
    { id: 3, label: 'City', key: 'city', tlabel: 'MDM_CITY', disabled: false, dataType: 'string', required: true },
  ], [
    { id: 4, label: 'State', key: 'state', tlabel: 'MDM_STATE', disabled: false, dataType: 'string', required: true },
    { id: 5, label: 'Region', key: 'region', tlabel: 'MDM_REGION', disabled: false, dataType: 'string', required: true },
    { id: 6, label: 'Country', key: 'country', tlabel: 'MDM_COUNTRY', disabled: false, dataType: 'string', required: false },
    { id: 7, label: 'Postal code', key: 'pincode', tlabel: 'MDM_PINCODE', disabled: false, dataType: 'numberOnly', required: true },
  ], [
    { id: 8, label: 'Group', key: 'group', tlabel: 'MDM_GROUP', disabled: false, dataType: 'string', required: false },
    { id: 9, label: 'Category', key: 'category', tlabel: 'MDM_CATEGORY', disabled: false, dataType: 'string', required: false },
    { id: 10, label: 'Logistics Spoc - Email ID', key: 'distribution_emails', tlabel: 'MDM_LOGISTICS_SPOC_EMAIL', disabled: false, dataType: 'string', required: false },
    { id: 11, label: 'Logistics Spoc - Mobile Number', key: 'distribution_phone_numbers', tlabel:'MDM_LOGISTICS_SPOC_MOBILE', disabled: false, dataType: 'number', required: false },
  ], [
    { id: 12, label: 'Logistics Representative', key: 'manager', tlabel: 'MDM_LOGISTICS_REP', info: true, disabled: false, dataType: 'string', required: false },
    { id: 13, label: 'Representative Mobile', key: 'phone', tlabel: 'MDM_LOGISTICS_REP_MOBILE', disabled: false, dataType: 'number', required: false },
    { id: 14, label: 'Representative Email', key: 'email_id', tlabel: 'MDM_LOGISTICS_REP_EMAIL', disabled: false, dataType: 'string', required: false },
    { id: 15, label: 'Exclude Truck Type', key: 'exclude_vehicles_list', tlabel: 'MDM_EXCLUDE_TRUCK_TYPE', disabled: false, formFieldType: 'MultiSelectList', required: false },
  ], [
    { id: 16, label: 'Sales Contact Name', key: 'sales_name', tlabel: 'MDM_SALES_CONTACT_NAME', disabled: false, dataType: 'string', required: false },
    { id: 17, label: 'Sales Contact Mobile', key: 'sales_phone', tlabel: 'MDM_SALES_CONTACT_MOBILE', disabled: false, dataType: 'number', required: false },
    { id: 18, label: 'Sales Contact Email', key: 'sales_email', tlabel: 'MDM_SALES_CONTACT_EMAIL', disabled: false, dataType: 'string', required: false },
    { id: 19, label: 'Customer Logistic Leader', key: 'customer_logistic_leader', tlabel: 'MDM_CUSTOMER_LOGISTIC_LEADER', disabled: false, dataType: 'string', required: false, formFieldType: 'debounce_dropdown' },
  ], [
    { id: 20, label: 'Loading Start Time', key: 'loading_time_start', tlabel: 'MDM_LOADING_START_TIME', disabled: false, dataType: 'date', formFieldType: 'time-picker', required: false },
    { id: 21, label: 'Loading End Time', key: 'loading_time_end', tlabel: 'MDM_LOADING_END_TIME', disabled: false, dataType: 'date', formFieldType: 'time-picker', required: false },
    { id: 22, label: 'Unloading Start Time', key: 'unloading_time_start', tlabel: 'MDM_UNLOADING_START_TIME', disabled: false, dataType: 'date', formFieldType: 'time-picker', required: false },
    { id: 23, label: 'Unloading End Time', key: 'unloading_time_end', tlabel: 'MDM_UNLOADING_END_TIME', disabled: false, dataType: 'date', formFieldType: 'time-picker', required: false },
  ], [
    { id: 24, label: 'Status', key: 'status', tlabel: 'MDM_STATUS', disabled: false, dataType: 'string', formFieldType: 'dropdown', values: ['Active', 'Inactive'], required: true },
    { id: 25, label: 'Ports Associated', key: 'ports_associated', tlabel: 'MDM_PORTS_ASSOCIATED', disabled: false, formFieldType: 'MultiSelectList', feature: 'exim_enabled', required: false },
    { id: 26, label: 'Display Reference Name', key: 'display_reference_name', tlabel: 'MDM_DISPLAY_REFERENCE_NAME', disabled: false, dataType: 'string', required: false },
    { id: 27, label: 'EPOD Group', key: 'epod_group', tlabel: 'MDM_EPOD_GROUP', disabled: false, dataType: 'string', required: false },
    { id: 32, label: 'Courier Ref Id', key: 'courier_ref_id', disabled: false, dataType: 'string', required: false },
    { id: 37, label: 'Non Operation Start Time', key: 'non_operation_time_start', disabled: false, dataType: 'date', formFieldType: 'time-picker', required: false },
    { id: 38, label: 'Non Operation End Time', key: 'non_operation_time_end', disabled: false, dataType: 'date', formFieldType: 'time-picker', required: false },
  ],
  [
    { id: 28, label: 'Optima Category', tlabel: 'MDM_OPTIMA_CATEGORY', key: 'optima_category', disabled: false, dataType: 'string', required: false },
    { id: 29, label: 'Customer Type', tlabel: 'MDM_CUSTOMER_TYPE', key: 'customer_type', disabled: false, dataType: 'string', formFieldType: 'dropdown', values: [], required: false },
  ],
  [{ id: 35, label: 'Latitude', key: 'consignee_latitude', disabled: false, dataType: 'number', formFieldType: 'lat-long', required: true },
    { id: 36, label: 'Longitude', key: 'consignee_longitude', disabled: false, dataType: 'number', formFieldType: 'lat-long', required: true },
  ],
  // ! Always keep the below array item in the last index
  [
    { id: 30, label: 'Combine delivery with other consignees', key: 'combine', tlabel: 'MDM_COMBINE_DELIVERY_WITH_OTHER_CONSIGNEE', info: true, disabled: false, dataType: 'boolean', formFieldType: 'switch', activeText: 'YES', inactiveText: 'NO', required: false },
    { id: 31, label: 'De-couple Deliveries', key: 'delivery_do_not_combine', tlabel: 'MDM_DE_COUPLE_DELIVERY', info: true, disabled: false, dataType: 'boolean', formFieldType: 'switch', activeText: 'YES', inactiveText: 'NO', required: false },
    { id: 32, label: 'Overseas Customer', key: 'overseas_customer', tlabel: 'MDM_OVERSEAS_CUSTOMER', disabled: false, dataType: 'boolean', formFieldType: 'switch', activeText: 'YES', inactiveText: 'NO', feature: 'exim_enabled', required: false },
    { id: 33, label: 'Notifications Enabled', tlabel: 'MDM_NOTIFICATIONS_ENABLED', key: 'notifications_enabled', disabled: false, dataType: 'boolean', formFieldType: 'switch', activeText: 'YES', inactiveText: 'NO', required: false },
    { id: 34, label: 'Login Active Status', tlabel: 'MDM_LOGIN_ACTIVE_STATUS', key: 'login_active_status', disabled: false, dataType: 'boolean', formFieldType: 'switch', activeText: 'ACTIVE', inactiveText: 'INACTIVE', required: false },
  ]
];

export const dispatchSchedule = [
  [
    { id: 29, label: 'Monday', key: 'monday', disabled: false, dataType: 'boolean', formFieldType: 'switch', activeText: 'YES', inactiveText: 'NO', required: false },
    { id: 30, label: 'Tuesday', key: 'tuesday', disabled: false, dataType: 'boolean', formFieldType: 'switch', activeText: 'YES', inactiveText: 'NO', required: false },
    { id: 31, label: 'Wednesday', key: 'wednesday', disabled: false, dataType: 'boolean', formFieldType: 'switch', activeText: 'YES', inactiveText: 'NO', required: false },
    { id: 32, label: 'Thursday', key: 'thursday', disabled: false, dataType: 'boolean', formFieldType: 'switch', activeText: 'YES', inactiveText: 'NO', required: false },
    { id: 33, label: 'Friday', key: 'friday', disabled: false, dataType: 'boolean', formFieldType: 'switch', activeText: 'YES', inactiveText: 'NO', required: false },
    { id: 34, label: 'Saturday', key: 'saturday', disabled: false, dataType: 'boolean', formFieldType: 'switch', activeText: 'YES', inactiveText: 'NO', required: false },
    { id: 35, label: 'Sunday', key: 'sunday', disabled: false, dataType: 'boolean', formFieldType: 'switch', activeText: 'YES', inactiveText: 'NO', required: false },
  ],
];

export const maxDisplayColumn = 8;

export const additionalUploads = [{
  name: 'Additional details',
  eventName: 'additionalBulkupload',
  getExcelFromAPI: true,
  uploadEmitMethod: 'additionalBulkupload',
}];

